import {createAsyncThunk} from '@reduxjs/toolkit';

import {IRpcDeleteResponse} from 'shared/types/rpc';

import {REPORT_CONFIGURATION_SLICE} from '../report-configuration-constants';
import {IReportConfigurationDataDto} from '../report-configuration-dto';
import {
    deleteDrillDownParameterRequest,
    TDeleteDrillDownParameterRequestArgs,
    TDrillDownParameterPostRequestArgs,
    fetchDDChildReportQueryParameters,
    IFetchDDChildReportQueryParametersArgs,
    fetchDrillDownParameters,
    IFetchDrillDownParametersArgs,
    postDrillDownOarameter,
} from './dd-parameters-configuration-api';
import {IReportDdParameter} from './dd-parameters-configuration-types';

export const updateDrilldownParameter = createAsyncThunk<
    IReportDdParameter,
    TDrillDownParameterPostRequestArgs
>(
    `${REPORT_CONFIGURATION_SLICE}/updateDrilldownParameter`, async (args, {rejectWithValue}) => {
        try {
            const result = await postDrillDownOarameter(args);
            return result.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const deleteDrilldownParameter = createAsyncThunk<
    IRpcDeleteResponse, TDeleteDrillDownParameterRequestArgs>(
        `${REPORT_CONFIGURATION_SLICE}/deleteDrilldownParameter`, async (args, {rejectWithValue}) => {
            try {
                const result = await deleteDrillDownParameterRequest(args);
                return result.data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadDrilldownParameters = createAsyncThunk<IReportDdParameter[], IFetchDrillDownParametersArgs>(
    `${REPORT_CONFIGURATION_SLICE}/loadDrilldownParameters`, async (args, {rejectWithValue}) => {
        try {
            const {data: reportDdParameters} = await fetchDrillDownParameters(args);
            return reportDdParameters;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadDDChildReportQueryParameters = createAsyncThunk<{
    queryParameters: IReportConfigurationDataDto['queryParameters'];
}, IFetchDDChildReportQueryParametersArgs>(
    `${REPORT_CONFIGURATION_SLICE}/loadDDChildReportQueryParameters`, async (args, {rejectWithValue}) => {
        try {
            const {data: reportDdParameters} = await fetchDDChildReportQueryParameters(args);
            return reportDdParameters;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
